import { useTranslation } from 'react-i18next'

import { Text } from '@chakra-ui/react'

export const Copyright = () => {
	const { t } = useTranslation('footer')
	return (
		<Text
			color="white"
			textStyle="body-text-6"
			textAlign={{ md: 'center' }}
		>
			{t('copyright', { currentYear: new Date().getFullYear().toString() })}
		</Text>
	)
}
